import { type ValidatedWizardStepsConfig } from "@krakentech/blueprint-onboarding"
import { type MeterPowerAnalysisRouteNames } from "@/routes/meterPowerAnalysis"
import {
    MeterPowerAnalysisWizardRouteGuard,
    meterPowerAnalysisWizardRouteGuardHelpers,
} from "../contexts/powerAnalysisWizardContext"
import { type MeterPowerAnalysisFormValues } from "../types/meterPowerAnalysisFormValues"

type MeterPowerAnalysisRouteGuardProps = {
    steps: ValidatedWizardStepsConfig<MeterPowerAnalysisRouteNames, MeterPowerAnalysisFormValues>
}

export const MeterPowerAnalysisRouteGuard = ({ steps }: MeterPowerAnalysisRouteGuardProps) => {
    const {
        composeValidators,
        validateFormValues,
        redirectToLastValidStepInHistory,
        validateLinearHistory,
    } = meterPowerAnalysisWizardRouteGuardHelpers

    const validateStep = composeValidators(
        validateLinearHistory,
        validateFormValues.fromSteps(steps)
    )

    return (
        <MeterPowerAnalysisWizardRouteGuard
            validateStep={validateStep}
            onInvalidStep={redirectToLastValidStepInHistory}
        />
    )
}
